import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import { MerchantSiteViewModel } from '@app/api/models';

import { MerchantActions, MerchantSelectors } from '../../store/merchant.slice';

@Component({
  selector: 'app-merchant-sites',
  templateUrl: './merchant-sites.component.html',
  styleUrls: ['./merchant-sites.component.scss'],
})
export class MerchantSitesComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectSitesLoading
  );
  isLoaded$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectSitesLoaded
  );
  hasError$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectSitesLoadError
  );
  data$: Observable<MerchantSiteViewModel[]> = this.store.select(
    MerchantSelectors.selectSiteList
  );
  sitesByMerchantId$: Observable<MerchantSiteViewModel[]> = this.store.select(
    MerchantSelectors.selectSiteListByMerchantId
  );
  activeSite$: Observable<MerchantSiteViewModel | null> = this.store.select(
    MerchantSelectors.selectSiteByMerchantId
  );
  siteId = '';

  readOnly?: boolean;

  private subs = new SubSink();

  constructor(
    private readonly store: Store,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.route.queryParams.subscribe((params) => {
      if (params['siteId']) {
        this.siteId = params['siteId'];
        this.store.dispatch(
          MerchantActions.setSiteId.trigger({ siteId: this.siteId })
        );
      }
    });

    this.subs.sink = this.route.data.subscribe(
      (data) => (this.readOnly = !!data['readOnly'])
    );

    if (!this.readOnly) {
      this.store.dispatch(MerchantActions.loadSites.trigger());
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
